import MediaLibraryPanel from './MediaLibraryPanel';
import useDesignerStore from './designerStore';

const CardImagePanel = ({ activeOrgId }) => {
  const { selectedObjectId, updateObject } = useDesignerStore();

  const handleSelect = (media) => {
    if (!selectedObjectId) return;

    updateObject(selectedObjectId, {
      src: media.url,
      originalSrc: media.url,
      mediaId: media._id,
    });
  };


  return (
    <MediaLibraryPanel
      organizationId={activeOrgId}
      type="image"
      selectable
      onSelect={handleSelect}
    />
  );
};

export default CardImagePanel;
